import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { StyledTableCell } from "../common/styles";
import { ColorPallet } from "../../utils/colorPallet";
import { BatchShelfHeaderData } from "../../utils/constants";
import BatchShelfInnerRow from "./batchShelfInnerRow";
import { TableCell } from "@mui/material";

// BatchShelfTable.tsx
const BatchShelfTable = ({ shelf }: { shelf: any }) => {
  const batchData = shelf?.batches?.map((batch: any) => ({
    id: Number(batch.id),
    Batch: batch.batch_no,
    MedicineName: batch.pharmacy_medicine?.name || "-",
    RemainingQty: `${batch.quantity - batch.quantity_sold}`,
    ProductionDate: new Date(batch.production_date).toLocaleDateString(),
    SupplierName: batch.supplier?.supplier_company_name || "-",
  }));
  return (
    <Box sx={{ mt: 3 }}>
      <TableContainer sx={{ maxHeight: "70vh", overflow: "auto" }}>
        <Table
          stickyHeader
          sx={{ border: "1px solid #D3D3D3", borderCollapse: "collapse" }}
        >
          <TableHead>
            <TableRow sx={{ height: "12px" }}>
              {BatchShelfHeaderData.map((header: any, index: number) => (
                <StyledTableCell
                  key={index}
                  sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 2,
                    color: ColorPallet.primaryGrey,
                    fontSize: "16px",
                    fontWeight: 500,
                    border: "1px solid #D3D3D3",
                  }}
                >
                  {header}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {batchData && batchData?.length > 0 ? (
              batchData?.map((batch: any) => (
                <BatchShelfInnerRow key={batch.id} batch={batch} />
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No Data Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default BatchShelfTable;
